import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-relatorio-laudo-proprietario',
  templateUrl: './relatorio-laudo-proprietario.component.html',
  styleUrls: ['./relatorio-laudo-proprietario.component.scss']
})
export class RelatorioLaudoProprietarioComponent implements OnInit {


  @Input() template;
  imgDocumento;
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    if(this.template && this.template.elements) {
      this.imgDocumento = this.template.elements.find( e => e.name == "documentoImg" && e.value );
    }
  }

}
